// import { FieldValue } from 'firebase/firestore'
// import { initializeProxy } from './fbProxy'
// import { proxyConfig } from './config'
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import envConfig from './config';

const firebaseConfig = envConfig.firebase;

// const firebaseConfig = {
//   apiKey: "AIzaSyCptfVWf5dHgWbLp_BCfjs5RhXtvBabRjc",
//   authDomain: "monash-portal-dev.firebaseapp.com",
//   databaseURL: "https://monash-portal-dev.firebaseio.com",
//   projectId: "monash-portal-dev",
//   storageBucket: "monash-portal-dev.appspot.com",
//   messagingSenderId: "462013370613",
//   appId: "1:462013370613:web:5a63c09edf70a3291a75bc",
//   measurementId: "G-RR4Q3HM06V"
// };

// const proxyConfig = {
//     authHost: 'links-dev.m.monash',
//     firestoreHost: 'links-dev.m.monash',
//     functionsHost: 'links-dev.m.monash',
//   }

// Initialize Firebase w/proxy
// const proxy = initializeProxy(firebaseConfig, proxyConfig)
// const auth = proxy.connectAuthProxy()
// const fs = proxy.connectFirestoreProxy()
// const storage = proxy.connectStorageProxy()
// const fn = proxy.connectFunctionsProxy()

// Normal fb
const firebaseApp = initializeApp(firebaseConfig);
const fa = getAuth(firebaseApp);
const fs = getFirestore(firebaseApp);

export {
  //   auth,
  fs,
  //   FieldValue,
  //   fn
  fa,
};
